import {Injectable} from '@angular/core';
import {ToastService} from "@app/_services/toast.service";

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {
    constructor(private toastService: ToastService) {
    }

    copyToClipboard(value: string, itemName: string): Promise<void> {
        if (!navigator.clipboard) {
            this.toastService.showDanger("Error", `Failed to copy "${value}" to clipboard. Please select and copy it manually.`);
            console.error("navigator.clipboard is unavailable (insecure context or unsupported browser)");
            return Promise.resolve();
        }

        return navigator.clipboard.writeText(value).then(
            () => {
                this.toastService.showStandard("Success", `${itemName} copied to clipboard`);
            },
            err => {
                this.toastService.showDanger("Error", `Failed to copy "${value}" to clipboard. Please select and copy it manually.`);
                console.error("Could not copy text: ", err);
            }
        );
    }
}
